import React from 'react';

interface LeftArrowIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

const LeftArrowIcon: React.FC<LeftArrowIconProps> = ({ 
  width = 20, 
  height = 21, 
  color = '#0D0D0D',
  className,
  style 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      fill="none" 
      viewBox="0 0 20 21"
      className={className}
      style={style}
    >
      <path 
        d="M11.3118 6.81344C11.5071 6.61818 11.8229 6.61818 12.0182 6.81344C12.2135 7.0087 12.2135 7.32456 12.0182 7.51982L9.03805 10.5L12.0182 13.4801C12.2135 13.6754 12.2135 13.9912 12.0182 14.1865C11.8229 14.3817 11.5071 14.3817 11.3118 14.1865L7.97848 10.8532C7.78322 10.6579 7.78322 10.342 7.97848 10.1468L11.3118 6.81344Z" 
        fill={color}
      />
    </svg>
  );
};

export default LeftArrowIcon;

